module.exports = "https://s91588.cdn.ngenix.net/home-frontend/_next/static/images/desktopDialogAppImage-26ff20e2c17e8cf14b76c1d293c1ac4a.png";